import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import dayjs from 'dayjs';
import { find, get, isEmpty } from 'lodash';
import { Space, Button, Form, Alert, Radio, Upload, Modal, Row, Col, Input, Divider } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import * as Yup from 'yup';
import * as constants from '../constants';


import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';
import companies from '../../companies';
import currentuser from '../../currentuser';

const { currentUserHasRights } = common;

const { SelectInput, TextInput, TextArea, CheckboxInput, DatePickerInput, NumberInput, UserRegistrationsGrid, DisplayFormikState } = core;
const ButtonGroup = Button.Group;
const FormItem = Form.Item;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class NewReportForm extends Component {

    state = {
        fileList: [],
        uploading: false,
        previewVisible: false,
        previewImage: '',
        fileError: '',
        categories: [],
    }

    UNSAFE_componentWillMount() {
        let categories = this.props.picklists.reportCategories.filter(c => c.visible);
        this.setState({
            categories: categories
        })
    }

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            try {
                if (this.state.fileList.length < 1) {
                    await this.props.onSave(values, undefined, false); //save, not submit
                } else {
                    await this.props.onSave(values, this.state.fileList[0], false); //save, not submit
                }
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);
                setErrors();
            }
        } else {
            setSubmitting(false)
        }
    }
    onSaveAndSubmit = async (values, { setSubmitting, setErrors, }) => {
        let valid = await this.formik.validateForm();
        if (isEmpty(valid)) {
            if (this.props.onSave) {
                try {
                    if (this.state.fileList.length < 1) {
                        await this.props.onSave(values, undefined, true); //save and submit
                    } else {
                        await this.props.onSave(values, this.state.fileList[0], true); //save and submit
                    }
                    setSubmitting(false);
                } catch (error) {
                    setSubmitting(false);
                    setErrors();
                }
            } else {
                setSubmitting(false)
            }
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'NewReportForm', key);
    }

    FormSchema = () => {
        let schema = Yup.object().shape({
            displayname: Yup.string().required('*'),
            contactPerson: Yup.string().required('*'),
            contactCompany: Yup.string().required('*'),
            contactFunction: Yup.string().required('*'),
            occasion: Yup.string().required('*'),
            gift: Yup.string().required('*'),
            amount: Yup.number().required('*'),
            date: Yup.date().required('*'),
            idReportCategory: Yup.number().integer().required('*'),
            idReportType: Yup.number().integer().required('*'),
            declaration: Yup.bool().when(
                'idReportType',
                (idReportType, schema) => (idReportType == 1 || idReportType == 2) ? Yup.bool().required('*').oneOf([true], '*') : schema,
            )
        })

        return schema;
    }
    onChange = e => {
        this.formik.setFieldValue('idReportType', e.target.value);
    };

    handleCancel = () => this.setState({ previewVisible: false });


    CreateForm = (props) => {
        const radioStyle = {
            display: 'inline',
            height: '30px',
            lineHeight: '30px',
        };
        const { fileList } = this.state;
        const fprops = {
            onRemove: (file) => {
                this.setState((state) => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            beforeUpload: (file) => {
                this.setState(state => ({
                    fileList: [file],
                }));
                return false;
            },
            onPreview: async file => {
                if (file.type.startsWith("image")) {
                    if (!file.url && !file.preview) {
                        file.preview = await getBase64(file);
                        file.url = file.preview;
                    }

                    this.setState({
                        previewImage: file.url || file.preview,
                        previewVisible: true,
                    });
                }
            },
            fileList,
        };

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <TextInput {...props} name="displayname" readOnly={true} label={this.label("Employee")} formItemLayout={formItemLayout} />
                <Form.Item label={this.label("ReportType")} {...formItemLayout}>
                    <Radio.Group disabled={this.props.readOnly} onChange={this.onChange} value={props.values.idReportType}>
                        <Radio style={radioStyle} value={common.REPORT_TYPES.IGive}>
                            {this.label("IGive")}
                        </Radio>
                        <Radio style={radioStyle} value={common.REPORT_TYPES.IReceive}>
                            {this.label("IReceive")}
                        </Radio>
                        <Radio style={radioStyle} value={common.REPORT_TYPES.IDecline}>
                            {this.label("IDecline")}
                        </Radio>
                    </Radio.Group>
                </Form.Item>

                <Row align="middle">
                    <Col span={17} offset={5} >
                        <Divider className="formDivider" orientation="left">{this.label(`Contact${props.values.idReportType}`)}</Divider>
                    </Col>
                </Row>

                <TextInput {...props} name="contactPerson" label={this.label("ContactPerson")} formItemLayout={formItemLayout} />
                <TextInput {...props} name="contactCompany" label={this.label("ContactCompany")} formItemLayout={formItemLayout} />
                <CheckboxInput {...props} name="governmentCompany" label={this.label("GovernmentCompany")} formItemLayout={formItemLayout} />
                <TextInput {...props} name="contactFunction" label={this.label("ContactFunction")} formItemLayout={formItemLayout} />

                <Row align="middle">
                    <Col span={17} offset={5} >
                        <Divider className="formDivider" orientation="left">{this.label(`Occasion${props.values.idReportType}`)}</Divider>
                    </Col>
                </Row>
                <TextArea {...props} name="occasion" label=' ' colon={false} rows={3} formItemLayout={formItemLayout} />

                <Row align="middle">
                    <Col span={17} offset={5} >
                        <Divider className="formDivider" orientation="left">{this.label(`Gift${props.values.idReportType}`)}</Divider>
                    </Col>
                </Row>
                <TextArea {...props} name="gift" label=' ' colon={false} rows={3} formItemLayout={formItemLayout} />

                <SelectInput {...props} name="idReportCategory" nameField="name" idField="id" items={this.state.categories} label={this.label("Category")} formItemLayout={formItemLayout} />
                <Form.Item {...formItemLayout} label={this.label("Amount")}>
                    <Row align="middle">
                        <Col span={10}>
                            <NumberInput {...props} decimalSeparator=',' step={0.01} precision={2} name="amount" min={0} formItemLayout={formItemLayout} />
                        </Col>
                        <Col span={6} >
                            <a href='https://www1.oanda.com/currency/converter/' target="_blank">currency converter</a>
                        </Col>
                    </Row>
                </Form.Item>
                <DatePickerInput {...props} name="date" showTime={false} label={this.label("Date")} formItemLayout={formItemLayout} />
                {(props.values.idReportType == common.REPORT_TYPES.IGive || props.values.idReportType == common.REPORT_TYPES.IReceive) &&
                    <>
                        <CheckboxInput {...props} name="declaration" label={this.label("Declaration")} formItemLayout={formItemLayout} />
                        <Row align="middle">
                            <Col span={16} offset={6} >
                                <span style={{ display: 'block', marginTop: -10 }} >{this.label(`Declaration${props.values.idReportType}`)}</span>
                                <br />
                            </Col>
                        </Row>
                    </>
                }

                <Form.Item label={this.label("File")}{...formItemLayout} hasFeedback={this.state.fileList.length < 1} validateStatus={this.state.fileError}>
                    <Upload {...fprops}>
                        <Button>
                            <UploadOutlined /> {this.label("SelectFile")}
                        </Button>
                    </Upload>
                </Form.Item>

                <br />

                <FormItem {...tailFormItemLayout}>
                    <ButtonGroup className='entity-form-btns'>
                        <Button disabled={props.isSubmitting} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting} > {this.label("Save")} </Button>
                    </ButtonGroup>
                    <Button style={{ marginLeft: 25 }} disabled={props.isSubmitting} onClick={() => this.onSaveAndSubmit(props.values, props)} > {this.label("SaveAndSubmit")} </Button>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                <Modal open={this.state.previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={this.state.previewImage} />
                </Modal>
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true} validateOnBlur={false} validateOnChange={false}
                initialValues={this.props.datacontext}
                validationSchema={this.FormSchema()}
                onSubmit={this.onSave}
                innerRef={p => (this.formik = p)}
            >
                {(props) => this.CreateForm(props)}
            </Formik>
        );
    }
}
function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {
})(NewReportForm);


